<section class="main_section" *ngIf="!getLoader">
    <div class="h-100 w-100">
        <div class="header">
            <div class="header-text">Template</div>
            <div class="close-image justify-content-end">
                <!-- <div class="combine_section">
                    <div  class="action-icons">
                        <img src="./../../../../../../../assets/images/master/delete-icon.svg" alt=""
                        (click)="deleteComponent(templateData?.id)">
                    </div>
                    <div class="hr_line"></div>
                    <div class="action-icons">
                        <img src="./../../../../../../../assets/images/master/edit-icon.svg" alt=""
                        (click)="editComponent(templateData?.id)">
                    </div>
                </div> -->
                <div class="editCompo d-flex">
                    <button class="edit_btn" (click)="editTemplate(templateData?.id)">
                        <img src="assets/images/master/edit-icon.svg" alt="edit">
                    </button>
                    <button class="edit_btn" (click)="deleteComponent(templateData)">
                        <img src="assets/images/master/delete-icon.svg" alt="delete">
                    </button>
                </div>
                <div class="action-icons_1" (click)="cancel()">
                    <img src="../../../../../../../../../../assets/images/close.svg" alt="">
                </div>
            </div>
        </div>
        <div class="body_section">
            <div class="registration">
                <div class="registrtaion-img">
                    <img [src]="templateData.screenShot != null ? templateData?.screenShot : '../../../../../../../../assets/images/master/11.png'"
                        alt="">
                </div>

            </div>
            <div class="registration-txt mt-3 d-flex flex-column gap-2 justify-content-between">
                <div class="top_sec d-flex flex-column gap-2">
                    <div class="first_sec common_sec">
                        <div class="template_name commom_text">{{(templateData?.name | titlecase) ?? 'N/A'}}</div>
                        <div class="template_desc common_text2">{{(templateData?.desc | titlecase) ?? 'N/A'}}</div>
                    </div>
                    <div class="second_sec row common_sec">
                        <div class="temp_industry col-6 mb-3">
                            <div class="temp_display commom_text">{{templateData.subIndustry.name ?
                                (templateData?.subIndustry?.name | titlecase) : 'N/A'}}</div>
                            <div class="text common_text2">Industry</div>
                        </div>
                        <div class="temp_status col-6 mb-3">
                            <div class="temp_display commom_text"
                                [ngClass]="{'active-true': templateData?.active === true, 'active-false': templateData?.active === false}">
                                {{templateData?.active === true ? 'Active' : 'Inactive'}}</div>
                            <div class="text common_text2">Status</div>
                        </div>
                        <div class="temp_licence col-6">
                            <div class="temp_display commom_text">{{(templateData?.templateCategory | titlecase) ??
                                'N/A'}}</div>
                            <div class="text common_text2">Licence</div>
                        </div>
                        <div class="temp_numPages col-6">
                            <div class="temp_display commom_text">{{(templateData?.pages?.length) ?? 'N/A'}}</div>
                            <div class="text common_text2">No. of Pages</div>
                        </div>
                    </div>
                    <!-- <div class="third_sec">

                    </div> -->
                </div>
                <div class="bottom_layer" *ngIf="hasPermission">
                    <div class="bottom_sec" *ngIf="templateData?.approvalStatus==='PENDING'">
                        <div class="approval d-flex justify-content-end gap-3">
                            <div class="reject common_btn cursor-pointer" data-bs-toggle="modal"
                                data-bs-target="#exampleModalCenter1"> <img class="icon_img"
                                    src="https://d2yx15pncgmu63.cloudfront.net/prod-images/771972c1748504087973Vector (2).png"
                                    alt="">
                                Reject</div>
                            <div class="approve common_btn cursor-pointer" data-bs-toggle="modal"
                                data-bs-target="#exampleModalCenter"> <img class="icon_img"
                                    src="https://d2yx15pncgmu63.cloudfront.net/prod-images/723966c1748504211081Icon left.png"
                                    alt="">
                                Approve</div>
                        </div>
                    </div>
                </div>
                <div class="status_layer" *ngIf="!hasPermission">
                    <div class="approve common_btn d-flex align-items-center justify-content-between">
                        Template Status <span
                            [ngClass]="{'approved' :templateData?.approvalStatus =='APPROVED','pending': templateData?.approvalStatus == 'PENDING','rejected' : templateData?.approvalStatus == 'REJECTED','in-progress' : templateData?.approvalStatus == 'INPROGRESS'}">{{templateData?.approvalStatus
                            ? (templateData?.approvalStatus |
                            titlecase) : 'N/A'}}</span>
                    </div>
                </div>
                <div class="bottom_layer d-flex align-items-center justify-content-end"
                    *ngIf="!hasPermission && (templateData?.approvalStatus != 'APPROVED' && templateData?.approvalStatus != 'PENDING')">
                    <div class="approve request-approve-btn d-flex align-items-center gap-1 common_btn cursor-pointer"
                        (click)="updateTemplateStatus('PENDING')"> <img class="icon_img"
                            src="https://d2yx15pncgmu63.cloudfront.net/prod-images/723966c1748504211081Icon left.png"
                            alt="">
                        Request for Approval</div>
                </div>
                <div class="bottom_layer"
                    *ngIf="hasPermission && (templateData?.approvalStatus != 'PENDING'&& templateData?.approvalStatus != 'INPROGRESS')">
                    <div class="approve common_btn d-flex align-items-center justify-content-between">
                        Change Approval Status
                        <mat-form-field appearance="outline" class="outline_none_form">
                            <mat-select [(ngModel)]="templateData.approvalStatus"
                                (selectionChange)="onStatusChange($event)" [ngClass]="{
        'green-text': templateData?.approvalStatus === 'APPROVED',
        'red-text': templateData?.approvalStatus === 'REJECTED'
        }">
                                <!-- If the current status is APPROVED -->
                                <ng-container *ngIf="templateData?.approvalStatus === 'APPROVED'">
                                    <!-- Display 'APPROVED' as the selected, but disabled, option -->
                                    <mat-option [value]="'APPROVED'" disabled>APPROVED</mat-option>
                                    <!-- Provide 'REJECT' as the only selectable choice -->
                                    <mat-option [value]="'REJECTED'">REJECT</mat-option>
                                </ng-container>

                                <!-- If the current status is REJECTED -->
                                <ng-container *ngIf="templateData?.approvalStatus === 'REJECTED'">
                                    <!-- Display 'REJECTED' as the selected, but disabled, option -->
                                    <mat-option [value]="'REJECTED'" disabled>REJECTED</mat-option>
                                    <!-- Provide 'APPROVE' as the only selectable choice -->
                                    <mat-option [value]="'APPROVED'">APPROVE</mat-option>
                                </ng-container>

                                <!-- Fallback for other statuses (e.g., PENDING, DRAFT) -->
                                <ng-container
                                    *ngIf="templateData?.approvalStatus !== 'APPROVED' && templateData?.approvalStatus !== 'REJECTED'">
                                    <mat-option [value]="'APPROVED'">APPROVE</mat-option>
                                    <mat-option [value]="'REJECTED'">REJECT</mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                        <!-- <select class="status-dropdown cursor-pointer" [ngClass]="{
                'green-text': templateData?.approvalStatus === 'APPROVED',
                'red-text': templateData?.approvalStatus === 'REJECTED'
            }" [(ngModel)]="templateData.approvalStatus" (change)="onStatusChange(templateData.approvalStatus)"
                            aria-placeholder="select status">
                            <ng-container *ngIf="templateData?.approvalStatus === 'APPROVED'">
                                <option [ngValue]="'APPROVED'" disabled>APPROVED</option>
                                <option [ngValue]="'REJECTED'" class="red-bg">REJECT</option>
                            </ng-container>
                            <ng-container *ngIf="templateData?.approvalStatus === 'REJECTED'">
                                <option [ngValue]="'REJECTED'" disabled>REJECTED</option>
                                <option [ngValue]="'APPROVED'" class="green-bg">APPROVE</option>
                            </ng-container>

                        </select> -->
                    </div>

                </div>
                <div class="rejectReason" *ngIf="templateData?.approvalStatus == 'REJECTED'">
                    <div class="text common_text2">Rejected Reason</div>
                    <div class="temp_display commom_text">{{(templateData?.rejectedReason | titlecase) ??
                        'N/A'}}</div>
                </div>
                <!-- <div class="d-flex justify-content-between align-items-center">
                  <div class="simpo_template_name">{{templateData?.name | titlecase}}</div>
                  <div class=""
                    [ngClass]="{'active-true': templateData?.active === true, 'active-false': templateData?.active === false}">
                    {{templateData?.active === true ? 'Active' : 'Inactive'}}
                  </div>
                </div>
                <div class="all_types">
                    <div class="text">
                        <div class="header_text_1">
                            Business Sub Industry
                        </div>
                        <div class="header_value">
                            {{templateData?.subIndustry?.name | titlecase}}
                        </div>
                        <div class="header_value">
                          Description: {{templateData?.desc === null ? 'N/A' : templateData?.subIndustry?.desc}}
                        </div>
                        <div class="header_value">
                          Created on {{templateData?.createdTimeStamp | date: 'mediumDate'}}
                        </div>
                        <div class="header_value">
                            No of pages: {{templateData?.pages.length}} {{templateData?.pages?.pageName}}
                        </div>
                    </div>
                </div> -->
                <!-- <div class="text">
                    <div class="header-text_1">Simpo Page Name</div> : <div class="header-value">{{ data?.pageData?.simpoName | titlecase}}</div>
                </div>
                <div class="text">
                    <div class="header-text_1">Category</div> : <div class="header-value">{{ data?.pageData?.subIndustry?.name}}</div>
                </div> -->
                <!-- <div class="header-text">Reference URl :  {{ data?.data?.refUrl}}</div> -->
                <!-- <div class="description"> {{ data?.pageData?.category?.name}} &nbsp;&nbsp;{{ data?.data?.subIndustries?.name}}</div> -->

                <!-- <p class="template-category">Template category</p>
                <div class="buttons w-fit ml-auto">
                  <div (click)="changeTemplatecategory('FREE')"
                    [ngClass]="{'selected-tab left-tab' : templateData.templateCategory != 'PREMIUM'}">
                    FREE
                  </div>
                  <div (click)="changeTemplatecategory('PREMIUM')"
                    [ngClass]="{'selected-tab right-tab' : templateData.templateCategory == 'PREMIUM'}">
                    PREMIUM
                  </div>
                </div> -->

            </div>
        </div>
    </div>
</section>
<!--Modal-->
<div class="modal fade" id="exampleModalCenter" #approveModalElement tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content custom-content">
            <div class="header">
                <div class="modal-title" id="exampleModalLongTitle">Approve Template</div>
                <!-- <button type="button" class="close-btn" data-bs-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button> -->
            </div>
            <div class="modal-body">
                Are you sure you want to approve this template? Once approved template will
                be live
            </div>
            <div class="footer w-100">
                <button type="button" class="approve-btn" (click)="updateTemplateStatus('APPROVED')">Approve</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    aria-label="Close">Cancel</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" #rejectionModalElement id="exampleModalCenter1" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content custom-content">
            <div class="header">
                <div class="modal-title" id="exampleModalLongTitle">Reject Template</div>
                <!-- <button type="button" class="close-btn" data-bs-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button> -->
            </div>
            <div class="modal-body">
                Are you sure you want to reject this template?
                <div class="reason">
                    <div class="mt-3">Reject Reason *</div>
                    <mat-form-field class="sfull-width domain-input w-100 mt-3" appearance="outline">
                        <input matInput placeholder="Enter Reason " [(ngModel)]="rejectedReason" />
                    </mat-form-field>
                </div>
            </div>
            <div class="footer">
                <button type="button" class="reject-btn" (click)="updateTemplateStatus('REJECTED')">Reject
                    Template</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    aria-label="Close">Cancel</button>
            </div>
        </div>
    </div>
</div>